import { InfoIF } from "./types";

export const info: InfoIF = {
  name: "John Doe",
  phone: "123-456-7890",
  email: "johndoe@gmail.com",
  website: "www.johndoe.com",
  linkedin: "linkdin.com/ln/johndoe",
  github: "github.com/johndoe",
  college: "Univerisity of California",
  major: "BS Computer Science",
  graduation: "Aug 2019 - May 2023",
  gpa: "3.65",
  languages: "Java, Python, Javascript/HTML/CSS, Bash, SQL",
  tools: "Node.js, React, Express.js",
  frameworks: "Github/Git, Intelliji, AWS, Docker",
  project: [
    {
      id: "",
      title: "NLP Project",
      link: "github.com/johndoe/nlp-project",
      desc1: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quas, quasi.",
      desc2: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolorum eos cumque dolor.",
      desc3: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
      desc4: "",
      desc5: "",
    },
  ],
  experience: [
    {
      id: "",
      position: "Developer",
      company: "Google",
      location: "Mountain View, CA",
      date: "Aug 2023 - Present",
      desc1: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatibus.",
      desc2: "Lorem ipsum dolor sit amet consectetur adipisicing.",
      desc3: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda iste ipsa earum et.",
      desc4: "",
      desc5: "",
    },
  ],
};
